import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
import '../../assets/scripts/sticky.min.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 7000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
}); 
 var industrial = new Swiper('.section2 .swiper-container', {
    slidesPerView: 2,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    speed:500,
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2,
        spaceBetween: '1.5625%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        spaceBetween: '1.5625%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    },
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
});

$(document).ready(function() {
  if ($(window).width() > 768) {
      
  const $window = $(window);
  const $image = $('#scaling-image');
  const $video = $('#video-player')[0];
  
  // 初始图片尺寸
  const initialWidth = $image.width();
  const initialHeight = $image.height();
  
  // 最大缩放比例
  const maxScale = 1.7;
  
  // 触发视频播放的滚动位置（像素）
  const videoTriggerPoint = $(".section3").offset().top;
  const scrollTop = $window.scrollTop();     
  // 如果已经滚动到触发点
  if (scrollTop >= videoTriggerPoint && scrollTop < $(".section4").offset().top - 1300) {
    $(".section3 .content").addClass("fixed");
      imageHidden = false;
      $video.pause();
      $image.fadeIn(300);
  }else if(scrollTop > $(".section4").offset().top - 1300 && scrollTop < $(".section4").offset().top - 200 && !imageHidden) {
    imageHidden = true;
    $image.fadeOut(300);
    $video.play();
  }
  else if(scrollTop >=0 && scrollTop  < videoTriggerPoint) {
    $(".section3 .content").removeClass("fixed");
    $(".section3 .content").removeClass("absolute");
    imageHidden = true;
  }else if(scrollTop > $(".section4").offset().top - $(".section3 .content").height() && scrollTop < $(".section5").offset().top) {
    $(".section3 .content").removeClass("fixed");
    $(".section3 .content").addClass("absolute");
  }else if (scrollTop < $(".section4").offset().top - $(".section3 .content").height() && scrollTop > $(".section3").offset().top) {
      $(".section3 .content").addClass("fixed");
      $(".section3 .content").removeClass("absolute");
  }else {
    imageHidden = false;
    $video.pause();
    $image.fadeIn(300);
  }


  // 如果图片仍然可见，调整其大小
  if (!imageHidden) {
      // 计算缩放比例（0到maxScale之间）
      let scale = 1 + ( scrollTop - videoTriggerPoint ) * 0.0008;
      
      // 限制缩放比例不超过最大值
      scale = Math.min(scale, maxScale);
      
      // 应用缩放
      $image.css({
          'transform': `scale(${scale})`,
          'transform-origin': 'center center'
      });
  }

  // 图片是否已经消失
  let imageHidden = true;
  // 监听滚动事件
  $window.on('scroll', function() {
      const scrollTop = $window.scrollTop();     
      // 如果已经滚动到触发点
      if (scrollTop >= videoTriggerPoint && scrollTop < $(".section4").offset().top - 1300) {
        $(".section3 .content").addClass("fixed");
          imageHidden = false;
          $video.pause();
          $image.fadeIn(300);
      }else if(scrollTop > $(".section4").offset().top - 1300 && scrollTop < $(".section4").offset().top - 200 && !imageHidden) {
        imageHidden = true;
        $image.fadeOut(300);
        $video.play();
      }
      else if(scrollTop >=0 && scrollTop  < videoTriggerPoint) {
        $(".section3 .content").removeClass("fixed");
        $(".section3 .content").removeClass("absolute");
        imageHidden = true;
      }else if(scrollTop > $(".section4").offset().top - $(".section3 .content").height() && scrollTop < $(".section5").offset().top) {
        $(".section3 .content").removeClass("fixed");
        $(".section3 .content").addClass("absolute");
      }else if (scrollTop < $(".section4").offset().top - $(".section3 .content").height() && scrollTop > $(".section3").offset().top) {
         $(".section3 .content").addClass("fixed");
         $(".section3 .content").removeClass("absolute");
      }else {
        imageHidden = false;
        $video.pause();
        $image.fadeIn(300);
      }


      // 如果图片仍然可见，调整其大小
      if (!imageHidden) {
          // 计算缩放比例（0到maxScale之间）
          let scale = 1 + ( scrollTop - videoTriggerPoint ) * 0.0008;
          
          // 限制缩放比例不超过最大值
          scale = Math.min(scale, maxScale);
          
          // 应用缩放
          $image.css({
              'transform': `scale(${scale})`,
              'transform-origin': 'center center'
          });
      }
  });
  }

  
  // 窗口大小调整时重新计算初始尺寸
  $window.on('resize', function() {
      if (!imageHidden) {
          $image.css({
              'width': 'auto',
              'height': 'auto'
          });
      }
  });
});

var swiper = new Swiper(".section4 .mySwiper", {
    navigation: {
      nextEl: ".section4 .swiper-button-next",
      prevEl: ".section4 .swiper-button-prev",
    },
});


// 数字滚动
var istrue = true;
var s = $(window).scrollTop();

if (s > $(".section4").offset().top + 200  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();   
    if (s > $(".section4").offset().top + 200  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)            
        };
        istrue = false;
        
    };
})
